/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Cli_IntroInputs */

const en_pc_tut_cli_intro = /** @type {(inputs: Pc_Tut_Cli_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pdfcraft-cli brings the same engine to scripts, and an opt-in MCP server lets AI agents use it too.`)
};

const zh_pc_tut_cli_intro = /** @type {(inputs: Pc_Tut_Cli_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pdfcraft-cli 把同一套引擎带进脚本，可选的 MCP 服务器还能让 AI 智能体使用它。`)
};

/**
* | output |
* | --- |
* | "pdfcraft-cli brings the same engine to scripts, and an opt-in MCP server lets AI agents use it too." |
*
* @param {Pc_Tut_Cli_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_cli_intro = /** @type {((inputs?: Pc_Tut_Cli_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Cli_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_cli_intro(inputs)
	return zh_pc_tut_cli_intro(inputs)
});
export { pc_tut_cli_intro as "pc.tut.cli.intro" }